import { Component, ComponentFactoryResolver, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UserWizardComponent } from "../user.wizard";
import { UserSitesSelectionComponent } from "./user.sites.selection.component";
import { UserSiteSelectioniwizardService } from "./user.site.selection.service";
import { ValuesExchangeProvider } from "@nrwl/common-lib";
@Component({
  selector: "site-selection-wizard",
  providers: [UserSiteSelectioniwizardService],
  templateUrl: "../../../wizard.template.html",
  styleUrls: ["../../../wizard.component.style.scss", "../wizard.user.style.scss", "../../../wizard.button.style.scss"]
})
export class UserSiteSelectionWizard extends UserWizardComponent {
  
  constructor(
    wizardService: UserSiteSelectioniwizardService,
    changeDetectorRef: ChangeDetectorRef,
    activatedRoute: ActivatedRoute,
    factoryResolver: ComponentFactoryResolver,
    private exchange: ValuesExchangeProvider) {
    super(wizardService, changeDetectorRef, activatedRoute, factoryResolver);
    
  }
  resolveComponentType(pageId: any) {
    if(pageId === "user.sites.selection.component.html") {
      return UserSitesSelectionComponent;
    }
    
    else {
      console.error("Unrecognized template name:", pageId);
      return null;
    }
  }

  toggleFinish() {
    const siteObject = this.wizardService.onApply();
    if (siteObject && siteObject.selectedSites) {
      this.exchange.notifyListeners('selectedSites', siteObject.selectedSites);
    }
    this.toggleClose();
  }
  
  toggleClose() {
    this.wizardService.toggleClose(
      () => this.onClose.emit(true)
    );
  }
}
